import { PageMeta } from "@/components/PageMeta";
import { legalDocuments } from "@/content/legalDocuments";

const CANONICAL_ORIGIN = process.env.REACT_APP_CANONICAL_ORIGIN;

export default function LegalPage({ documentKey }) {
  const document = legalDocuments[documentKey];
  const pageUrl = `${CANONICAL_ORIGIN}${document.path}`;
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${pageUrl}#webpage`,
    url: pageUrl,
    name: document.title,
    description: document.description,
    datePublished: document.effectiveDateIso,
    dateModified: document.updatedDateIso,
    isPartOf: { "@id": `${CANONICAL_ORIGIN}/#website` },
  };

  return <>
    <PageMeta title={`${document.title} | FU Research`} description={document.description} path={document.path} schema={schema} />
    <div className="legal-page shell" data-testid={`legal-${documentKey}-page`}>
      <header className="legal-hero" data-testid={`legal-${documentKey}-header`}>
        <p className="eyebrow" data-testid={`legal-${documentKey}-eyebrow`}>FU Research / Legal</p>
        <div className="legal-title-grid">
          <div>
            <h1 data-motion="title" data-testid={`legal-${documentKey}-title`}>{document.title}</h1>
            <p className="legal-intro" data-motion="metadata" data-testid={`legal-${documentKey}-introduction`}>{document.intro}</p>
          </div>
          <dl className="legal-date" data-motion="metadata" data-testid={`legal-${documentKey}-date`}>
            <dt data-testid={`legal-${documentKey}-effective-label`}>Effective</dt><dd data-testid={`legal-${documentKey}-effective-date`}>{document.effectiveDate}</dd>
            <dt data-testid={`legal-${documentKey}-updated-label`}>Last updated</dt><dd data-testid={`legal-${documentKey}-updated-date`}>{document.updatedDate}</dd>
          </dl>
        </div>
      </header>

      <div className="legal-layout" data-motion="body" data-testid={`legal-${documentKey}-content-entrance`}>
        <aside className="legal-contents" aria-label={`${document.title} contents`} data-testid={`legal-${documentKey}-contents`}>
          <p data-testid={`legal-${documentKey}-contents-label`}>Contents</p>
          {document.sections.map((section, index) => <a key={section.id} href={`#${section.id}`} data-testid={`legal-${documentKey}-contents-link-${index + 1}`}>{section.title}</a>)}
        </aside>

        <div className="legal-body" data-testid={`legal-${documentKey}-body`}>
          {document.sections.map((section, sectionIndex) => <section id={section.id} key={section.id} data-testid={`legal-${documentKey}-${section.id}-section`}>
            <span className="legal-section-number" data-testid={`legal-${documentKey}-${section.id}-number`}>{String(sectionIndex + 1).padStart(2, "0")}</span>
            <div>
              <h2 data-testid={`legal-${documentKey}-${section.id}-heading`}>{section.title}</h2>
              {section.paragraphs.map((paragraph, paragraphIndex) => <p key={paragraph} data-testid={`legal-${documentKey}-${section.id}-paragraph-${paragraphIndex + 1}`}>{paragraph}</p>)}
              {section.bullets && <ul data-testid={`legal-${documentKey}-${section.id}-list`}>
                {section.bullets.map((item, itemIndex) => <li key={item} data-testid={`legal-${documentKey}-${section.id}-item-${itemIndex + 1}`}>{item}</li>)}
              </ul>}
            </div>
          </section>)}
        </div>
      </div>
    </div>
  </>;
}